import { useMemo } from "react";
import { useOrgMembers } from "./useOrgMembers";

// #2075 — resolve a Cognito sub (the "setBy" on a ring-state row,
// docs/score/ring-state.md) to a display name. Same account-common call and
// response envelope PeopleManager.jsx's scribe-role load already uses (#736):
// GET /org/{orgId}/member via useOrgMembers, which pages the whole org
// (#2339 — a single unpaged page used to silently hide any member past it).
// Keyed by userId so a caller can resolve a sub in O(1) and RingStateSection
// never has a raw sub left to fall back to — an unresolved id (a former
// member, a service-written row, or the fetch failing outright) resolves to
// `{}`/a miss, and the caller supplies the neutral fallback.
export function useOrgMembersById(orgId) {
  const { members } = useOrgMembers(orgId);

  return useMemo(
    () => Object.fromEntries(members.map((m) => [m.userId, m])),
    [members],
  );
}

export default useOrgMembersById;
